<template>
  <section class="wordCheckedComponent">
    <audio ref="ref_audio" controls @ended="overAudio">
      <source :src="currentVoiceUrl">
    </audio>
    <ul class="word-wraper">
      <li v-for="(item, index) in wordListFormat" :key="index" class="word-item" :class="{active: item.id === currentWord.id}">
        <el-image :src="item.imgUrl" fit="fit" @click.native="imgClick(item)" />
        <el-button class="voice-icon" type="primary" circle @click="voiceClick(item, index)">
          <i :class="index === currentIndex?'suonaAnimation':''" class="suonaIcon" />
        </el-button>
        <div class="bottom-bar">
          <el-checkbox v-model="checkedArr" :disabled="checkedArr.length >= 10" :label="item.id">{{ item.name }}</el-checkbox>
        </div>
      </li>
      <li v-if="wordListFormat.length === 0" style="text-align: center; margin-top: 50px;color: #828481;">暂无数据</li>
    </ul>
  </section>
</template>

<script>
// import _ from 'lodash'
// import { applyData, findApplyHistory } from '@/api/refund/refundApply'
export default {
  // model: {
  //   prop: 'checkedWordIds',
  //   event: 'change'
  // },
  props: {
    // checkedType: {
    //   type: String,
    //   default: 'WORD_MEANS'
    // },
    checkedWordIds: {
      type: Array,
      default: function () {
        return []
      }
    },
    wordList: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      currentIndex: -1,
      currentVoiceUrl: '',
      currentWord: {}
    }
  },
  computed: {
    checkedArr: {
      get() {
        return this.checkedWordIds
      },
      set(val) {
        this.$emit('update:checkedWordIds', val)
      }
    },
    wordListFormat () {
      const arr = []
      for (const item of this.wordList) {
        arr.push({
          id: item.id,
          name: item.wordName,
          imgUrl: item.cardChartPath,
          voice: item.pronunciationPath,
          mouthShapePath: item.mouthShapePath
        })
      }
      // if (this.checkedType === 'WORD_MEANS') {
      //   for (const item of this.wordList) {
      //     arr.push({
      //       id: item.id,
      //       name: item.wordName,
      //       imgUrl: item.cardChartPath,
      //       voice: item.pronunciationPath,
      //       mouthShapePath: item.mouthShapePath
      //     })
      //   }
      // } else if (this.checkedType === 'SENTENCE_PATTERN_MEANS') {
      //   for (const item of this.wordList) {
      //     arr.push({
      //       id: item.id,
      //       name: item.wordName,
      //       imgUrl: item.cardChartPath,
      //       voice: item.pronunciationPath
      //     })
      //   }
      // } else if (this.checkedType === 'HIGH_FREQUENCY_MEANS') {
      //   for (const item of this.wordList) {
      //     arr.push({
      //       id: item.id,
      //       name: item.wordName,
      //       imgUrl: item.cardChartPath,
      //       voice: item.pronunciationPath,
      //       mouthShapePath: item.mouthShapePath
      //     })
      //   }
      // }
      return arr
    }
  },
  watch: {

  },
  created () {

  },
  methods: {
    imgClick (item) {
      this.currentWord = item
      this.$store.commit('courseStep/SET_currentClickData', item)
    },
    voiceClick (item, index) {
      this.currentIndex = index
      this.currentVoiceUrl = item.voice
      this.$nextTick(() => {
        this.$refs.ref_audio.load()
        this.$refs.ref_audio.play()
      })
    },
    overAudio() {
      this.currentIndex = -1
    }
  }
}
</script>

<style lang='scss'>
.wordCheckedComponent{
  .word-wraper{
    .word-item{
      display: inline-block;
      position: relative;
      margin: 0 8px 16px 8px;
      padding: 16px;
      background-color: #F7F6F4;
      border-radius: 12px;
      transition: all 0.3s;
      width: 168px;
      border:2px solid transparent;
      &.active{
        border-color: #FCDA6F;
      }
      .el-image{
        cursor: pointer;
        width: 136px;height: 126px;
        border-radius: 8px;
        margin-bottom: 15px;
        background-color: white;
      }
      .voice-icon{
        position: absolute;
        right: 22px;
        top: 22px;
        padding: 7px;
        box-shadow: 0px 3px 6px rgba(248, 212, 91, 0.5);
        cursor: pointer;
        .suonaIcon{
          width:13px;
          height:11px;
          display: inline-block;
          background-image:url('../../../../assets/images/suona3.png');
            &.suonaAnimation{
              animation:myfirst 1s infinite;
            // /* Safari and Chrome */
            -webkit-animation:myfirst 1s infinite;
            }
        }
        @keyframes myfirst
        {
        0%   {background-image:url('../../../../assets/images/suona1.png');}
        50%  {background-image:url('../../../../assets/images/suona2.png');}
        100% {background-image:url('../../../../assets/images/suona3.png')}
        }

        @-webkit-keyframes myfirst /* Safari and Chrome */
        {
        0%   {background-image:url('../../../../assets/images/suona1.png');}
        50%  {background-image:url('../../../../assets/images/suona2.png');}
        100% {background-image:url('../../../../assets/images/suona3.png')}
        }
      }
      .bottom-bar{
        text-align: center;font-size: 14px;color: #45433D;
        .el-checkbox{
          display: inline-flex;
          justify-content: center;
          align-items: center;
        }
        .el-checkbox__label{
          max-width: 90px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
